module.exports = __webpack_public_path__ + "img/oiseau_qui_chante.afcf6497.jpg";